export enum FeatureName {
  RESERVATION_V2 = 'services.reservationsV2',
  AVAILABILITY_V2 = 'services.availabilityV2'
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/model/featureflags/feature-name.model.ts